// extracted by mini-css-extract-plugin
module.exports = {"section":"J_section__tLviE","scroll":"J_scroll__LUxb1"};